import clsx from 'clsx';

import { Button, Form, Table } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';

import { shorterFyID } from '@/utils/format';
import { Item4AIPayload, AIModuleEntity, Item4Company } from '../types';

type SelectChange = React.ChangeEvent<HTMLSelectElement>;

type ItemsTableProps = {
  formVisible: boolean;
  payload: Item4AIPayload;
  aiModuleSelected: AIModuleEntity;
  itemRows: Item4Company[];
  showForm: () => void;
  onCompanyChange: (event: SelectChange) => void;
  handleClose: () => void;
  handleItemDelete: (item: Item4Company) => void;
};

export const Items4CompanyTable = ({
  formVisible,
  payload,
  aiModuleSelected,
  itemRows,
  showForm,
  onCompanyChange,
  handleClose,
  handleItemDelete,
}: ItemsTableProps) => {
  return (
    <div className={clsx(formVisible ? 'd-lg-none' : '')}>
      {/* == company select to list items == */}
      <Form.Group className="mb-4">
        <Form.Label>Companies for AI module</Form.Label>
        <Form.Select
          aria-label="select company"
          className="mb-2"
          name="company_id"
          value={payload.company_id}
          onChange={onCompanyChange}
        >
          <option value="">Select a company...</option>
          {aiModuleSelected.companies?.map((c) => (
            <option key={c.company_id} value={c.company_id}>
              {c.label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      {/* item table under one company */}
      <div
        className="table-conainer-allow-scroll"
        style={{ maxHeight: '300px', overflowY: 'auto' }}
      >
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>#</th>
              <th>item_ID</th>
              <th>Action</th>
              <th>expanded_item_id</th>
              <th>length_formula</th>
              <th>factor value</th>
              <th>DELETE</th>
            </tr>
          </thead>
          <tbody>
            {itemRows.map((r, i) => (
              <tr key={i} className={clsx(r.deleting ? 'fadeout' : '')}>
                <td>{i + 1}</td>
                <td title={r.item_id}>{shorterFyID(r.item_id)}</td>
                <td>{r.action}</td>
                <td>{r.expanded_item_id || ''}</td>
                <td>{r.expansion_length_formula || ''}</td>
                <td>{r.formula_correction_factor || ''}</td>
                <td>
                  <Button
                    type="button"
                    variant="outline-danger"
                    className="btn-icon-only btn-xs"
                    onClick={() => handleItemDelete(r)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <div className="mt-4 d-flex justify-content-end gap-3 border-top pt-3">
        <Button type="button" variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button
          type="button"
          variant="dark"
          onClick={showForm}
          className={clsx(formVisible ? 'd-lg-none' : '')}
        >
          <FontAwesomeIcon icon={faPlus} /> Add Item
        </Button>
      </div>
    </div>
  );
};
